import { Component, OnInit, Inject } from '@angular/core';
import { FormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { ComponentBase, DialogData } from '@definitiv-packages/angular-dba-library';

import { DebitorModel, DebitorModelView, DebitorService, ProjectLanguage, SysLandModel, SysLandService } from '../../../../../roofsafetymanagement-library/src/public-api';

@Component({
  selector: 'app-create-debitor',
  templateUrl: './create-debitor.component.html',
  styleUrls: ['./create-debitor.component.scss'],
  standalone: false
})
export class CreateDebitorComponent extends ComponentBase<ProjectLanguage> implements OnInit {
  //#region 
  public Title: string = "";
  public debitor: DebitorModel | null = null;

  public landList: SysLandModel[] = [];

  private NummerControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.required, Validators.maxLength(20)]);
  private NameControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.required, Validators.maxLength(100)]);

  public StrasseControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(100)]);
  public PLZControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(10)]);
  public OrtControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(100)]);
  private TelefonControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(20)]);
  private EMailControl: FormControl<string | null> = new FormControl<string | null>(null, [Validators.maxLength(100)]);
  private LandControl: FormControl<SysLandModel | null> = new FormControl<SysLandModel | null>(null);

  public FormGroup = new UntypedFormGroup({
    nummerControl: this.NummerControl,
    nameControl: this.NameControl,
    strasseControl: this.StrasseControl,
    plzControl: this.PLZControl,
    ortControl: this.OrtControl,
    telefonControl: this.TelefonControl,
    emailControl: this.EMailControl,
    landControl: this.LandControl
  });
  //#endregion

  constructor(public dialogRef: MatDialogRef<CreateDebitorComponent>,
    public debitorService: DebitorService,
    public syslandService: SysLandService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData<DebitorModelView>
  ) { super(); }

  public async ngOnInit() {
    this.loading = true;

    this.landList = await this.syslandService.getList();

    if (this.data.mode == 'create') {
      this.Title = this.languageService.getText(this.language.debitorerstellen);
    } else if (this.data.mode == 'edit') {
      this.Title = this.languageService.getText(this.language.debitorbearbeiten);
    }

    if (this.data.data) {

      this.debitor = await this.debitorService.get(this.data.data.DebitorID);
      this.NummerControl.setValue(this.debitor.Nummer);
      this.NameControl.setValue(this.debitor.Name);
      this.StrasseControl.setValue(this.debitor.Strasse);
      this.PLZControl.setValue(this.debitor.PLZ);
      this.OrtControl.setValue(this.debitor.Ort);
      if (this.debitor.LandID)
        this.LandControl.setValue(this.landList.find(x => x.LandID == this.debitor?.LandID)!);

      this.TelefonControl.setValue(this.debitor.Telefon);
      this.EMailControl.setValue(this.debitor.EMail);
    }
    else {
      this.debitor = {} as DebitorModelView;

    }
    this.loading = false;
  }

  public async Save(): Promise<void> {
    this.FormGroup.markAllAsTouched();
    this.FormGroup.updateValueAndValidity();
    if (this.FormGroup.valid) {

      this.loading = true;
      this.debitor = new DebitorModel();

      if (this.data.mode == 'edit' && this.data.data)
        this.debitor.DebitorID = this.data.data?.DebitorID;

      this.debitor.Nummer = this.NummerControl.value!;
      this.debitor.Name = this.NameControl.value!;
      this.debitor.Strasse = this.StrasseControl.value ?? '';
      this.debitor.PLZ = this.PLZControl.value ?? '';
      this.debitor.Ort = this.OrtControl.value ?? '';
      if (this.LandControl.value)
        this.debitor.LandID = this.LandControl.value?.LandID;
      this.debitor.Telefon = this.TelefonControl.value ?? '';
      this.debitor.EMail = this.EMailControl.value ?? '';

      if (this.debitor.DebitorID > 0)       //Update
        var Item = await this.debitorService.put(this.debitor.DebitorID, this.debitor)
      else                                  // Insert
        var Item = await this.debitorService.post(this.debitor)

      this.loading = false;
      this.dialogRef.close(Item);
    }
  }

  OnMailClick() {
    if (this.EMailControl.value)
      window.open("mailto:" + this.EMailControl.value + '?subject=' + "roofsafetymanagement - Meine Nachricht", "_self");
  }

  openMaps() {
    var adress = this.StrasseControl.value + ", " + this.PLZControl.value + " " + this.OrtControl.value;
    const url = "https://www.google.com/maps/search/" + adress;
    window.open(url, '_blank');
  }
}
